import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

function degsToRadians(degs) {
  return (degs / 360) * (2 * Math.PI);
}

export default class PieChart extends React.Component {
  wrapperRef = React.createRef();

  static propTypes = {
    data: ImmutablePropTypes.listOf(
      ImmutablePropTypes.map.isRequired
      /*
      Contains({
        value: PropTypes.number.isRequired,
        color: PropTypes.string.isRequired
      })
      */
    ),
    showLabels: PropTypes.bool,
    size: PropTypes.number,
    lineWidth: PropTypes.number,
    className: PropTypes.string
  };

  static defaultProps = {
    showLabels: false,
    size: 250,
    lineWidth: 25
  };

  componentDidMount() {
    this.draw();
  }

  componentDidUpdate() {
    this.draw();
  }

  draw() {
    const canvas = this.wrapperRef.current;
    const c = canvas.getContext('2d');
    const center = this.props.size / 2;
    const lineWidth = this.props.lineWidth;
    const radius = center - lineWidth / 2;
    c.lineWidth = lineWidth;

    const dataTotal = this.props.data.reduce((r, datum) => {
      return r + datum.get('value');
    }, 0);
    let startAngle = degsToRadians(-90);

    // Draw loop
    this.props.data.forEach((datum, i) => {
      const section = (datum.get('value') / dataTotal) * 360;
      const endAngle = startAngle + degsToRadians(section);

      c.strokeStyle = datum.get('color');
      c.beginPath();
      c.arc(center, center, radius, startAngle, endAngle);
      c.stroke();
      startAngle = endAngle;
    });
  }

  render() {
    return (
      <canvas
        ref={this.wrapperRef}
        className={this.props.className}
        height={this.props.size}
        width={this.props.size}
      />
    );
  }
}
